import { render, staticRenderFns } from "./form-history-list.vue?vue&type=template&id=900c4924&"
import script from "./form-history-list.vue?vue&type=script&lang=js&"
export * from "./form-history-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "form-history-list.vue"
export default component.exports